module.exports = __webpack_public_path__ + "img/unimarkt-logo.399d641a.png";